// src/components/common/IntercomButton.js
import React from 'react';
import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { HelpCircle } from 'lucide-react';

// Styled icon without button background
const StyledHelpIcon = styled(HelpCircle, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  width: isMobile ? 20 : 24,
  height: isMobile ? 20 : 24,
  color: theme.palette.mode === 'dark'
    ? 'rgba(255, 255, 255, 0.5)'
    : 'rgba(0, 0, 0, 0.4)',
  cursor: 'pointer',
  transition: 'color 0.2s ease',
  '&:hover': {
    color: theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.8)'
      : 'rgba(0, 0, 0, 0.7)',
  }
}));

const IntercomButton = ({ onClick, isMobile = false }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Verificar si Intercom está disponible
    if (typeof window !== 'undefined' && window.Intercom) {
      // Mostrar el messenger de Intercom
      window.Intercom('show');
    } else {
      console.log('Intercom not available');
    }
    
    // Llamar al handler onClick si existe
    if (onClick) {
      onClick();
    }
  };

  return (
    <Tooltip title="Get help" placement="top" arrow>
      <StyledHelpIcon
        onClick={handleClick}
        size={isMobile ? 20 : 24}
        strokeWidth={1.5}
        isMobile={isMobile}
        aria-label="Get help"
      />
    </Tooltip>
  );
};

export default IntercomButton;